import { parseVttTimestampMap } from "./parse-vtt-timestamp-map.js";
//#region src/media/text/resolve-vtt-metadata.ts
/**
* Header-level text-segment metadata — the `X-TIMESTAMP-MAP` correlation scraped from a VTT segment's raw bytes.
* DOM-free (a plain fetch + regex parse): the native `<track>` parser in `media/dom/text` (`resolveVttSegment`)
* discards this header, so a caller that needs it (e.g. non-zero-PTS relocation) fetches the bytes itself.
*/
/**
* Fetch a VTT segment and scrape only its header metadata (no cue parsing).
*
* The native `<track>` parser (`media/dom/text`'s `resolveVttSegment`) discards `X-TIMESTAMP-MAP`, so reading it
* requires the raw bytes. This is a separate, caller-controlled fetch — the caller decides _when_ metadata is needed
* (e.g. once per source) rather than paying for it on every segment.
*/
async function resolveVttSegmentMetadata(url) {
	const text = await fetch(url).then((response) => response.text());
	return { timestampMap: parseVttTimestampMap(text) };
}
//#endregion
export { resolveVttSegmentMetadata };
